/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { PeriodType } from '../../../core/constants';
import { DefaultStorage, Persistor } from '../../../core/default-storage';

import { DATE_PERIOD } from './constants';

export interface DetailSettings {
  periodType: PeriodType;
}

const defaultStorage = new DefaultStorage();

class DetailSettingsPersistor implements Persistor<DetailSettings> {
  private storage: Storage;

  constructor(storage: Storage = defaultStorage) {
    this.storage = storage;
  }

  get periodType() {
    const value = this.storage.getItem(DATE_PERIOD) || defaultStorage.getItem(DATE_PERIOD);

    return value as PeriodType;
  }

  set periodType(value: PeriodType) {
    this.storage.setItem(DATE_PERIOD, value);
  }

  get instance(): DetailSettings {
    return {
      periodType: this.periodType
    };
  }

  public persist(payload: Partial<DetailSettings>) {
    if (payload.periodType) {
      this.periodType = payload.periodType;
    }
  }
}

/**  DetailSettings Sigleton instance */
let _instance: DetailSettingsPersistor | undefined;

if (!_instance) {
  _instance = new DetailSettingsPersistor(sessionStorage);
}

const detailSettingsPersistor = _instance;

export { detailSettingsPersistor, DetailSettingsPersistor };
